// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { initI18nReact } from 'typesafe-i18n/adapters/adapter-react'
import type { Locales, Translation, TranslationFunctions, Formatters } from './i18n-types'
import { baseLocale, getTranslationForLocale } from './i18n-util'
import { initFormatters } from './formatters'

const { component: TypesafeI18n, context: I18nContext } = initI18nReact<Locales, Translation, TranslationFunctions, Formatters>(baseLocale, getTranslationForLocale, initFormatters)

export { I18nContext }

export default TypesafeI18n
